<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('reward.inviteNum')" prop="inviteNum" >
        <a-input-number
          v-model="form.inviteNum"
          :min="1"
          :step="1"
          :placeholder="$t('reward.inputInviteNum')"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('reward.rewardType')" prop="type" >
        <a-select :placeholder="$t('reward.selectRewardType')" v-model="form.type">
          <a-select-option :key="0">{{ $t('reward.giveDiamond') }}</a-select-option>
          <a-select-option :key="1">{{ $t('reward.giveVip') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('reward.rewardValue')" prop="rewardNum" >
        <a-input-number :min="1" v-model="form.rewardNum" style="width: 100%" :placeholder="$t('reward.inputRewardNum')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReward, addReward, updateReward } from '@/api/invite/reward'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        inviteNum: null,

        type: null,

        rewardNum: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        inviteNum: [
          { required: true, message: this.$t('reward.inviteNumRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('reward.inviteNumMin'), trigger: 'change' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        inviteNum: null,
        type: null,
        rewardNum: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReward({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReward(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReward(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
